import { camelCase } from 'lib/utils/objectSerializer';

const initialState = {
  thresholdsLoading: true,
  thresholdsError: undefined,
  thresholds: undefined,

  missingItemsFixedLoading: true,
  missingItemsFixedError: undefined,
  missingItemsFixedMetric: undefined,

  missingItemsDynamicLoading: true,
  missingItemsDynamicError: undefined,
  missingItemsDynamicMetric: undefined,

  metricsLoading: true,
  metricsError: undefined,
  totalOrders: undefined,
  totalDeliveredOrders: undefined,
  totalRejectedOrders: undefined,
  lateOrders: undefined,
};

const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case 'FETCH_METRIC_THRESHOLDS_REQUEST': {
      return {
        ...state,
        thresholdsError: initialState.thresholdsError,
      };
    }
    case 'FETCH_MISSING_ITEMS_FIXED_METRIC_REQUEST': {
      return {
        ...state,
        missingItemsFixedError: initialState.missingItemsFixedError,
      };
    }
    case 'FETCH_MISSING_ITEMS_DYNAMIC_METRIC_REQUEST': {
      return {
        ...state,
        missingItemsDynamicError: initialState.missingItemsDynamicError,
      };
    }
    case 'FETCH_METRICS_DATA_REQUEST': {
      return {
        ...state,
        metricsError: initialState.metricsError,
      };
    }
    case 'FETCH_METRIC_THRESHOLDS_SUCCESS': {
      return {
        ...state,
        thresholdsLoading: false,
        thresholds: camelCase(action.payload),
      };
    }
    case 'FETCH_MISSING_ITEMS_FIXED_METRIC_SUCCESS': {
      return {
        ...state,
        missingItemsFixedLoading: false,
        missingItemsFixedMetric: camelCase(action.payload),
      };
    }
    case 'FETCH_MISSING_ITEMS_DYNAMIC_METRIC_SUCCESS': {
      return {
        ...state,
        missingItemsDynamicLoading: false,
        missingItemsDynamicMetric: camelCase(action.payload),
      };
    }
    case 'FETCH_METRICS_DATA_SUCCESS': {
      const totalOrders = action.payload.metrics.filter(
        (obj) => obj.name === 'total_orders',
      );
      const totalDeliveredOrders = action.payload.metrics.filter(
        (obj) => obj.name === 'total_delivered_orders',
      );
      const totalRejectedOrders = action.payload.metrics.filter(
        (obj) => obj.name === 'total_rejected_orders',
      );
      const lateOrders = action.payload.metrics.filter(
        (obj) => obj.name === 'wait_time_past_target_5min_cnt',
      );

      return {
        ...state,
        metricsLoading: false,
        totalOrders: camelCase(...totalOrders),
        totalDeliveredOrders: camelCase(...totalDeliveredOrders),
        totalRejectedOrders: camelCase(...totalRejectedOrders),
        lateOrders: camelCase(...lateOrders),
      };
    }
    case 'FETCH_METRIC_THRESHOLDS_FAILURE': {
      return {
        ...state,
        thresholdsLoading: false,
        thresholdsError: camelCase(action.payload),
        thresholds: undefined,
      };
    }
    case 'FETCH_MISSING_ITEMS_FIXED_METRIC_FAILURE': {
      return {
        ...state,
        missingItemsFixedLoading: false,
        missingItemsFixedError: camelCase(action.payload),
        missingItemsFixedMetric: undefined,
      };
    }
    case 'FETCH_MISSING_ITEMS_DYNAMIC_METRIC_FAILURE': {
      return {
        ...state,
        missingItemsDynamicLoading: false,
        missingItemsDynamicError: camelCase(action.payload),
        missingItemsDynamicMetric: undefined,
      };
    }
    case 'FETCH_METRICS_DATA_FAILURE': {
      return {
        ...state,
        metricsLoading: false,
        metricsError: camelCase(action.payload),
        totalOrders: initialState.totalOrders,
        totalDeliveredOrders: initialState.totalDeliveredOrders,
        totalRejectedOrders: initialState.totalRejectedOrders,
      };
    }
    default:
      return state;
  }
};

export default reducer;
